export const NOME_STATUS_ATIVO: Record<string, string> = {
  em_operacao: 'Em operação', com_defeito: 'Com defeito', em_manutencao: 'Em manutenção',
  desativado: 'Desativado', removido: 'Removido', a_confirmar: 'A confirmar',
};
export const NOME_PROPRIEDADE: Record<string, string> = { cliente: 'Do cliente', maza_locacao: 'MAZA · locação', maza_comodato: 'MAZA · comodato' };
export const NOME_EVENTO: Record<string, string> = { instalado: 'Instalado', trocado: 'Trocado', removido: 'Removido', reparado: 'Reparado', movido: 'Mudou de local', status: 'Mudou de situação' };

export interface Categoria { id: string; codigo: string; nome: string; pai_id: string | null; pai_nome: string | null; agrupador?: boolean; nivel?: Nivel }
export type Nivel = 'essencial' | 'componente' | 'consumivel';
export const NOME_NIVEL: Record<Nivel, string> = { essencial: 'Essencial', componente: 'Componente', consumivel: 'Consumível' };
export interface Modelo { id: string; fabricante: string; modelo: string; categoria_id: string }

export function dataBR(d: string | null | undefined): string {
  if (!d) return '—';
  const [a, m, dia] = d.slice(0, 10).split('-');
  return `${dia}/${m}/${a}`;
}
export function dinheiro(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—';
  return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
export const URL_ETIQUETA = (codigo: string) => `${location.origin}/q/${codigo}`;
